var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8571 6H8.14286C6.95982 6 6 6.95982 6 8.14286V23.8571C6 25.0402 6.95982 26 8.14286 26H23.8571C25.0402 26 26 25.0402 26 23.8571V8.14286C26 6.95982 25.0402 6 23.8571 6ZM16.7143 18.8571H14.5714V21C14.5714 21.3929 14.25 21.7143 13.8571 21.7143H12.4286C12.0357 21.7143 11.7143 21.3929 11.7143 21V11C11.7143 10.6071 12.0357 10.2857 12.4286 10.2857H16.7143C19.0759 10.2857 21 12.2098 21 14.5714C21 16.933 19.0759 18.8571 16.7143 18.8571ZM16.7143 13.1429H14.5714V16H16.7143C17.5 16 18.1429 15.3571 18.1429 14.5714C18.1429 13.7857 17.5 13.1429 16.7143 13.1429Z",
    fill: "#0072BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeParking);
export default __webpack_public_path__ + "static/media/free_parking.cc37ec6c5eaa503a72a9080d8cb9626e.svg";
export { ForwardRef as ReactComponent };